/**
 * AI CONTEXT
 * Purpose: memoized visual session stripe on timeline with tooltip + click.
 * Inputs: positioned session geometry and room color.
 * Used by: ClassScheduleTimeline.
 * Refactor: expose shared stripe style tokens for easier theme tuning.
 */
import { Tooltip } from "antd"
import React from "react"
import styled from "styled-components"

import { PositionedTimelineSession } from "#customTypes/composedTypes/classSessionTypes"

import SessionStripeTooltip from "./SessionStripeTooltip"

// Styled session stripe with hover effects
const StyledSessionStripe = styled.div<{ color: string }>`
  position: absolute;
  cursor: pointer;
  background-color: ${(props) => props.color};
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 2px;
  transition: all 0.2s ease;
  opacity: 1;

  &:hover {
    transform: scale(1.05);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
    z-index: 5;
    opacity: 1;
  }
`

// Memoized session component for better performance
const SessionStripe = React.memo(
  ({
    session,
    color,
    left,
    width,
    top,
    height,
    onClick,
  }: {
    session: PositionedTimelineSession
    color: string
    left: number
    width: number
    top: number
    height: number
    onClick: () => void
  }) => {
    return (
      <Tooltip
        title={<SessionStripeTooltip session={session} />}
        placement="right"
        arrow
      >
        <StyledSessionStripe
          color={color}
          style={{
            left: `${left}px`,
            width: `${width}px`,
            top: top + "px",
            height: `${height}px`,
          }}
          onClick={onClick}
        />
      </Tooltip>
    )
  }
)

export default SessionStripe
